export default __webpack_public_path__ + "static/media/cp_geo_qa.13a6ba92.svg";